import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CardForm from "../../Components/common/CardForm/CardForm";
import TextField from "../../Components/common/TextField/TextField";
import PasswordStrength from "../../Components/common/PasswordStrength/PasswordStrength";
import Backdrop from "../../Components/UI/Backdrop/Backdrop";

import { changePasswordRequest } from "../../store/actions/usersActions";

import { evaluatePassword } from "../../utils/passwordPolicy";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.users.loginLoading);
  const username = useSelector((state) => state?.users?.user?.username);
  const email = useSelector((state) => state?.users?.user?.email);
  const [inputs, setInputs] = useState({
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  const handleChanges = (e) => {
    setError("");
    const { name, value } = e.target;
    setInputs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const submitFormHandler = (e) => {
    e.preventDefault();
    if (!inputs.password.trim()) {
      setError("Password cannot be empty");
      return;
    }
    if (inputs.password !== inputs.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    const strength = evaluatePassword(inputs.password, { username, email });
    if (!strength.valid) {
      setError(strength.errors[0]);
      return;
    }
    dispatch(changePasswordRequest({ new_password: inputs.password }));
  };

  return (
    <CardForm
      title="Set a new password"
      subTitle="You must change your password before continuing."
      error={Boolean(error)}
      errorText={error}>
      <form onSubmit={submitFormHandler}>
        <TextField
          placeholder="Enter your new password"
          value={inputs.password}
          onChange={handleChanges}
          labelText="New password"
          name="password"
          required={true}
          error={Boolean(error)}
          type="password"
        />
        <PasswordStrength password={inputs.password} username={username} email={email} />
        <TextField
          placeholder="Confirm your new password"
          value={inputs.confirmPassword}
          onChange={handleChanges}
          labelText="Confirm password"
          name="confirmPassword"
          required={true}
          error={Boolean(error)}
          type="password"
        />
        <button className="card__form-btn" type="submit">
          Change password
        </button>
      </form>
      {loading && <Backdrop show={loading} />}
    </CardForm>
  );
};

export default ChangePassword;
